window.onload = function() {
	const elements = document.getElementsByClassName('article-script');
	const classes = elements[0].classList;
	var scriptClass = "";
	for (const className of classes) {
		if(className != "article-script") {
			scriptClass = className;
		}
	}
	const sprayForm = document.getElementById('sprayForm');
	if(sprayForm) {
		loadForm(sprayForm,scriptClass);
	} else {
		console.error(new Date().toLocaleString() + " No sprayForm div wrapper defined");
	}
}
	
function loadForm(sprayForm,scriptClass) {
	console.log(new Date().toLocaleString() + " loadForm started");
	var baseUrl = "https://www.spray.com/"
	var url = new URL(window.location.href);
	var myHostname = url.hostname;
	// Local developer sites (*.spray.local) call their own form API; otherwise they fall back to production.
	if(myHostname.includes("spray.com") || myHostname.includes("teejet") || myHostname.includes("fluidair") || myHostname.includes("sprayanalysis") || myHostname.includes("-sars") || myHostname.endsWith(".local")) {
		baseUrl = "https://" + url.hostname + "/";
		const link = document.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = "/styles/MSForm.css";
		sprayForm.appendChild(link);
	}
	if(myHostname.includes("pathosans.com")) {
		const link = document.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = "https://www.spray.com//styles/MSForm.css";
		sprayForm.appendChild(link);
	}
	const loaderDiv = document.createElement('div');
	loaderDiv.id = 'loader';
	sprayForm.appendChild(loaderDiv);
	var myPathname = decodeURIComponent(url.pathname);
	var myUrl = baseUrl + url.pathname;
	var encodedUrl = encodeURIComponent(url.protocol + "//" + url.hostname) +  myPathname.replaceAll('/','%2F');
    var apiURL = baseUrl + 'api/spray/form/formapi?url=' + encodedUrl + '&formName='
    if (typeof formName === 'undefined') {
        apiURL = apiURL + "Default";
    } else {
        apiURL = apiURL + formName;
    }
    fetch(apiURL)
		.then(response => {
			if (!response.ok) {
			  throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.json();
			})
		.then(data => {
			if(data.ErrorMessage != "") {
				var spanElement = document.createElement('span');
				spanElement.innerHTML = data.ErrorMessage;
				sprayForm.appendChild(spanElement);
				document.getElementById("loader").style.display = "none";
				console.error(new Date().toLocaleString() + " MSForm ERROR: " + data.ErrorMessage);
			} else {
				var formCaptureLoader = document.createElement('script');
				formCaptureLoader.setAttribute('src',data.FormCaptureLoaderUrl);
				formCaptureLoader.setAttribute('async',true);
				sprayForm.appendChild(formCaptureLoader);
				var formLoader = document.createElement('script');
				formLoader.setAttribute('src',data.FormLoaderUrl);
				formLoader.setAttribute('async',true);
				formLoader.onload = function() {
					formLoaded(url, data, sprayForm,scriptClass);
				}
				sprayForm.appendChild(formLoader);
			}
		})
		.catch(error => {
			document.getElementById("loader").style.display = "none";
			console.error(new Date().toLocaleString() + " There was a problem with the fetch operation for form API:" + error);
		});
}

function formLoaded(pageUrl, data, sprayForm,scriptClass) {
	console.log(new Date().toLocaleString() + " FormLoaderUrl loaded");
	//console.log("FormId: " + data.FormId);
	//console.log("FormApiBaseUrl: " + data.FormApiBaseUrl);
	//console.log("FormBaseUrl: " + data.FormBaseUrl + data.FormId);
	const shadow = sprayForm.attachShadow({ mode: "open" });
	const shadowRoot = sprayForm.shadowRoot;
	shadowRoot.appendChild(d365mktforms.createForm(
		data.FormId,
		data.FormApiBaseUrl,
		data.FormBaseUrl + data.FormId));

	shadowRoot.addEventListener("d365mkt-afterformload", function() {
		afterFormLoad(data, sprayForm, shadowRoot, scriptClass);
	});
	
	shadowRoot.addEventListener("d365mkt-formsubmit", function(event) {
		beforeFormSubmit(event, shadowRoot, data);
	});
}

function fileToBase64Pure(file, callback) {
  if (!file) {
	  callback('');
	  return;
  }

  const reader = new FileReader();

  reader.onload = function(event) {
	  // Get the base64 string and remove the data URL prefix
	  let base64String = event.target.result;

	  // Remove "data:mime/type;base64," prefix
	  if (base64String.indexOf(',') > -1) {
		  base64String = base64String.split(',')[1];
	  }

	  callback(base64String);
  };

  reader.onerror = function(error) {
	  // Return empty string on error
	  callback('');
  };

  reader.readAsDataURL(file);
}

// Collect file data from form
function collectFormData(form, callback) {
  const formElements = form.elements;
  let fileElement = null;

  // Find the file input element
  for (let i = 0; i < formElements.length; i++) {
	  const element = formElements[i];

	  // Handle file inputs only
	  if (element.type === 'file') {
		  fileElement = element;
		  break;
	  }
  }

  // Process file if present
  if (fileElement !== null && fileElement.files && fileElement.files[0]) {
	  const file = fileElement.files[0];

	  fileToBase64Pure(file, function(base64String) {
		  const fileData = {
			  fieldName: fileElement.name,
			  fileName: file.name,
			  fileType: file.type,
			  fileSize: file.size,
			  fileSizeMB: (file.size / (1024 * 1024)).toFixed(2),
			  fileData: base64String
		  };

		  callback(fileData);
	  });
  } else {
	  // No file to process
	  callback(null);
  }
}

// Validate file type and size
function validateFile(element) {
	const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
	const ALLOWED_TYPES = ['application/pdf', 'image/jpeg'];
	const ALLOWED_EXTENSIONS = ['.pdf', '.jpg', '.jpeg'];

	const file = element.files[0];
	const fileName = file.name.toLowerCase();
	const fileExtension = fileName.substring(fileName.lastIndexOf('.'));

	// Check file type
	if (!ALLOWED_TYPES.includes(file.type) && !ALLOWED_EXTENSIONS.includes(fileExtension)) {
		return {
			isValid: false,
			message: 'UploadFileTypeError'
		};
	}
	
	// Check file size
	if (file.size > MAX_FILE_SIZE) {
		const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
		return {
			isValid: false,
			message: 'UploadSizeError'
		};
	}
	
	return {
		isValid: true,
		message: ''
	};
}

function ShowUploadError(shadowRoot, data, messageKey) {
	var message = messageKey;
	console.log("ShowUploadError messageKey: " + messageKey);
	if(data.Messages[messageKey]) {
		message = data.Messages[messageKey];
	}
	let element = shadowRoot.getElementById("uploaderror");
	console.log("ShowUploadError element: " + element);
	if(element) {
		element.style.display = "block";
		element.innerText = message;
	}
}

function HideUploadError(shadowRoot) {
	console.log("HideUploadError: ");
	let element = shadowRoot.getElementById("uploaderror");
	console.log("HideUploadError element: " + element);
	if(element) {
		element.style.display = "none";
		element.innerText = "";
	}
}


function beforeFormSubmit(event, shadowRoot, data) {
	const debug = false;
	event.preventDefault();
	const formElement = shadowRoot.querySelector('form');
	if(!formElement) {
		console.error(new Date().toLocaleString() + " MS form unable to load");
		return;
	}
	HideUploadError(shadowRoot);
	const fields = data.Fields;
	var uploadFound = false;

	// Check if there's an upload field that needs validation
	for (let i = 0; i < fields.length; i++) {
		const field = fields[i];
		if(debug) console.log(new Date().toLocaleString() + " Field1: " + field.fieldName + " " + field.fieldType);
		const fieldElement = shadowRoot.querySelector('[name="' + field.fieldName + '"]');
		if(fieldElement) {
			if(debug) console.log(new Date().toLocaleString() + "    FieldElement: " + fieldElement.id);
			if(field.fieldType === 'UploadFileFormField') {
				if(!fieldElement.files[0]) {
					if(field.isRequired) {
						ShowUploadError(shadowRoot, data, "Required");
						return;
					}
				} else {
					const validation = validateFile(fieldElement);
					if (!validation.isValid) {
						if(debug) console.log('Upload validation failure: ', validation);
						ShowUploadError(shadowRoot, data, validation.message);
						return;
					} else {
						uploadFound = true;
					}
				}
				break;
			}
		}
	}

	if(uploadFound) {
		if(debug) console.log(new Date().toLocaleString() + "    Upload Found - starting file upload");
		try {
			// Collect file data only
			collectFormData(formElement, function(fileData) {
				if(debug) console.log('File Data:', fileData);

				// Prepare JSON payload with just the file
				const jsonPayload = {
					file: fileData,
					metadata: {
						submittedAt: new Date().toISOString(),
						userAgent: navigator.userAgent
					}
				}

				// Log the payload for debugging
				if(debug) console.log('JSON Payload:', jsonPayload);

				// API endpoint for file upload
				const apiUrl = '/api/spray/form/uploadfile';

				// Send POST request and wait for response
				fetch(apiUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(jsonPayload)
				})
				.then(response => response.json())
				.then(result => {
					console.log('Upload Success:', result);
					var uploadFilePath = "";
					// Access the uploadFilePath from the response
					if (result.status === 'success' && result.uploadFilePath) {
						uploadFilePath = result.uploadFilePath;
						console.log('Uploaded file path:', uploadFilePath);
						proceedWithFormSubmission(shadowRoot, data, formElement, uploadFilePath, debug);
					} else {
						ShowUploadError(shadowRoot, data, result.message);
						console.error('Upload Error:', result.message);
					}
				})
				.catch(error => {
					ShowUploadError(shadowRoot, data, 'UploadError');
					console.error('Upload Error:', error);
				});
			});
		} catch (error) {
			ShowUploadError(shadowRoot, data, 'UploadError');
			console.error('Submission error:', error);
		}
	} else {
		// No file upload needed, proceed directly with form submission
		proceedWithFormSubmission(shadowRoot, data, formElement, "", debug);
	}
}

function proceedWithFormSubmission(shadowRoot, data, formElement, uploadFilePath, debug) {
	if(debug) console.log(new Date().toLocaleString() + " Proceeding with form submission. Upload file path: " + uploadFilePath);

	var baseUrl = "https://www.spray.com"
	var url = new URL(window.location.href);
	var myHostname = url.hostname;
	if(!myHostname.includes("pathosans.com")) {
		baseUrl = "https://" + url.hostname;
	}
	// Set the download page URL field value if upload was successful
	if (uploadFilePath && uploadFilePath !== "") {
		const textFormBlocks = shadowRoot.querySelectorAll('[data-editorblocktype="TextFormField"]');
		textFormBlocks.forEach(block => {
			const inputField = block.querySelector('input[name="ssco_upload_pageurl"]');
			if (inputField) {
				const url = baseUrl + "/api/spray/form/downloadfile?f=" +  encodeURIComponent(uploadFilePath);
				inputField.value = url;
				if(debug) console.log(new Date().toLocaleString() + " Set ssco_upload_pageurl to: " + url);
			}
		});
	}

	const fields = data.Fields;
	var mappings = [];

	for (let i = 0; i < fields.length; i++) {
		const field = fields[i];
        var checkedCount = 1;
        if (field.fieldType == "MultiOptionSetFormField") {
            checkedCount = shadowRoot.querySelectorAll('input[name="' + field.fieldName + '"]:checked').length;
        }
        const fieldElement = shadowRoot.querySelector('[name="' + field.fieldName + '"]');
        if (debug) console.log(new Date().toLocaleString() + " Field: " + field.fieldName + " checkedCount: " + checkedCount + " fieldElement: " + fieldElement)
		if(fieldElement) {
			if(field.isHidden || field.isUsed) {
                if ((fieldElement.value === undefined || fieldElement.value.trim() === '') && checkedCount == 0) {
					if(debug) console.log(new Date().toLocaleString() + "  DISABLED");
					fieldElement.disabled = true;
				} else {
					if(field.leadMapping != "") {
						var mapping = { FormFieldName: field.fieldName, DataverseFieldName: field.leadMapping };
						mappings.push(mapping);
					}
					if(field.contactMapping != "") {
						var mapping = { FormFieldName: field.fieldName, DataverseFieldName: field.contactMapping };
						mappings.push(mapping);
					}
					if(field.leadMapping == "" && field.contactMapping == "") {
						var mapping = { FormFieldName: field.fieldName, DataverseFieldName: field.fieldName };
						mappings.push(mapping);
					}
				}
			} else {
				if(debug) console.log(new Date().toLocaleString() + "  NOT USED");
				fieldElement.disabled = true;
			}
		} else {
			if(field.isHidden || field.isUsed) {
				if(debug) console.error(new Date().toLocaleString() + " Unable to locate field: " + field.fieldName);
			}
		}
	}

	const topics = data.Topics;
	const topicBlocks = shadowRoot.querySelectorAll("[data-editorblocktype='Topic']");
	if(topicBlocks) {
		for (let i = 0; i < topicBlocks.length; i++) {
			const topicBlock = topicBlocks[i];
			const inputs = topicBlock.querySelectorAll('input');
			const name = inputs[0].name;
			const value = inputs[0].value
			var mappingTopic = {
				FormFieldName: name,
				DataverseFieldName: "msdynmkt_topicid;channels;optinwhenchecked",
				DataverseFieldValue: value + ";Email;true"
			};
			mappings.push(mappingTopic);
		}
	}

	const consentBlocks = shadowRoot.querySelectorAll("[data-editorblocktype='Consent']");
	if(consentBlocks) {
		for (let i = 0; i < consentBlocks.length; i++) {
			const consentBlock = consentBlocks[i];
			const inputs = consentBlock.querySelectorAll('input');
			const name = inputs[0].name;
			const value = inputs[0].value;
			var mappingPurpose = {
				FormFieldName: name,
				DataverseFieldName: "msdynmkt_purposeid;channels;optinwhenchecked",
				DataverseFieldValue: value + ";Email;true"
			};
			mappings.push(mappingPurpose);
		}
	}

	if(debug) console.log(new Date().toLocaleString() + " Mappings: " + JSON.stringify(mappings));
	const serializedForm = d365mktformcapture.serializeForm(formElement, mappings);
	var payload = serializedForm.SerializedForm.build();
	if(debug) console.log(new Date().toLocaleString() + " Payload: " + JSON.stringify(payload));
	const captureConfig = {
		FormId: data.FormId,
		FormApiUrl: data.FormApiBaseUrl
	}

	if(debug) console.log(new Date().toLocaleString() + " OverrideRedirectUrl: " + data.OverrideRedirectUrl);
	if(debug) console.log(new Date().toLocaleString() + " RedirectUrl: " + data.RedirectUrl);
	if(debug) return;

	d365mktformcapture.submitForm(captureConfig, payload)
		.then((result) => {
			if(data.OverrideRedirectUrl != "") {
				window.location.href = data.OverrideRedirectUrl;
			} else {
				if(data.RedirectUrl != "") {
					window.location.href = data.RedirectUrl;
				}
			}
		})
		.catch((error) => {
			console.error(new Date().toLocaleString() + " " + error);
		});
}	

function afterFormLoad(data, sprayForm, shadowRoot,scriptClass) {
	const debug = false;	
	const url = new URL(window.location.href);
	const SourceDetailsInput = url.protocol + "//" + url.hostname + url.pathname;
	const Domain = url.protocol + "//" + url.hostname;
	const UTMParameters = getUTMParamsFromCookie();
	const UTMSource = UTMParameters.source ? UTMParameters.source : "";
	if(debug) console.log(new Date().toLocaleString() + " UTM Source: "+UTMParameters.source);
	const UTMMedium = UTMParameters.medium ? UTMParameters.medium : "";
	const UTMCampaign = UTMParameters.campaign ? UTMParameters.campaign : "";
	const UTMTerm = UTMParameters.term ? UTMParameters.term : "";
	const UTMContent = UTMParameters.content ? UTMParameters.content : "";
	const lang = data.Language; 
	const formElement = shadowRoot.querySelector('form');
	if(!formElement) {
		document.getElementById("loader").style.display = "none";
		console.error(new Date().toLocaleString() + " MS form unable to load");
		return;
	}
	formElement.style.display= "none";

	const styleTag = shadowRoot.querySelector('style');
	if (styleTag && data.FormCssInline != "") {
		styleTag.textContent += data.FormCssInline;
	}

	if(data.PageURL.includes("DefaultFormConfiguration")) {
		console.error(new Date().toLocaleString() + " MSForm WARNING: Default form is being used");
	}
	if(scriptClass != "") {
		formElement.classList.add(scriptClass);
	}
	if(data.RedirectUrl != "") {
		formElement.setAttribute("data-redirecturl", data.RedirectUrl);
	}
	if(data.OverrideRedirectUrl != "") {
		formElement.setAttribute("data-redirecturl", data.OverrideRedirectUrl);
	}
	if(data.Messages["Error"] != "") {
		formElement.setAttribute("data-errormessage", data.Messages["Error"]);
	}

	if(data.Messages["Success"] != "") {
		formElement.setAttribute("data-successmessage", data.Messages["Success"]);
	}
	const elements = formElement.elements;
	const fields = data.Fields;

	const blockElements = shadowRoot.querySelectorAll('[data-editorblocktype]');
	var blockStyle = "";
	var submitButtonBlock = null;
    blockElements.forEach(blockElement => {
		blockType = blockElement.getAttribute("data-editorblocktype");
		if(debug) console.log(new Date().toLocaleString() + " Type: " + blockType);
		switch (blockType) {
			case "Consent":
			case "Topic":
				blockStyle = blockElement.style.cssText;
				blockElement.remove()
				break;
			case "SubmitButton":
				submitButtonBlock  = blockElement;
				var submitButton = blockElement.querySelector('button');
				if(submitButton) {
					if(debug) console.log(new Date().toLocaleString() + "   SubmitButton: ");
					const submitButtonSpan = submitButton.querySelector('span');
					if(submitButtonSpan) {
						if(data.SubmitButtonTranslation != "") {
							if(debug) console.log(new Date().toLocaleString() + "      Replace1: " + data.SubmitButtonTranslation);
							submitButtonSpan.textContent = data.SubmitButtonTranslation;
						} else {
							if(data.SubmitButton.labelText != "") {
								if(debug) console.log(new Date().toLocaleString() + "      Replace2: " + data.SubmitButton.labelText);
								submitButtonSpan.textContent = data.SubmitButton.labelText;
							}
						}
					}
				}
				break;
			case "UploadFileFormField": 
				var inputField = blockElement.querySelector('input');
				var fieldFound = false;
				if(inputField) {
					if(debug) console.log(new Date().toLocaleString() + "   Field: " + inputField.name);
					fieldFound = fields.find(field => field.fieldName.toLowerCase() === inputField.name.toLowerCase() && (field.isUsed));
				}
				if(!fieldFound) {
					if(debug) console.log(new Date().toLocaleString() + "   DISABLED");
					blockElement.remove();
				} else {
					const labelText = fieldFound.labelText != "" ? fieldFound.labelText : "";
					const placeholderText = fieldFound.placeholderText != "" ? fieldFound.placeholderText : "";
					const tooltipText = fieldFound.tooltipText != "" ? fieldFound.tooltipText : "";
					const defaultValue = (fieldFound.defaultValue != "" ? fieldFound.defaultValue : "");
					var fieldLabels = inputField.labels;
					fieldLabels.forEach(fieldLabel => {
						if(debug) console.log(new Date().toLocaleString() + "    Label: " + labelText);
						fieldLabel.innerHTML = labelText != "" ? labelText: fieldLabel.innerHTML;
						fieldLabel.placeholder = placeholderText;
						fieldLabel.title = tooltipText;
					});
					inputField.placeholder = placeholderText;
					inputField.title = tooltipText;
					if(fieldFound.isRequired) {
						if(debug) console.log(new Date().toLocaleString() + "    Required" );
						inputField.setAttribute("required", "required");
						blockElement.setAttribute("data-required", "required")
						if(data.Messages["Required"] != "") {
							inputField.addEventListener('invalid',  function() {
								inputField.setCustomValidity('');
								if (!inputField.validity.valid) {
								  inputField.setCustomValidity(data.Messages["Required"]);  
								}
							});	
						}
					} else {
						inputField.removeAttribute("required");
						blockElement.removeAttribute("data-required");
					}
				}
				break;
			case "TextFormField": 
			case "PhoneFormField": 
			case "DateTimeFormField": 
			case "TwoOptionFormField":
			case "TwoOptionFormField":
				var inputField = blockElement.querySelector('input');
				var fieldFound = false;
				if(inputField) {
					if(debug) console.log(new Date().toLocaleString() + "   Field: " + inputField.name);
					fieldFound = fields.find(field => field.fieldName.toLowerCase() === inputField.name.toLowerCase() && (field.isUsed || field.isHidden));
				}
				if(!fieldFound) {
					if(debug) console.log(new Date().toLocaleString() + "   DISABLED");
					blockElement.remove();
				} else {
					const labelText = fieldFound.labelText != "" ? fieldFound.labelText : "";
					const placeholderText = fieldFound.placeholderText != "" ? fieldFound.placeholderText : "";
					const tooltipText = fieldFound.tooltipText != "" ? fieldFound.tooltipText : "";
					const defaultValue = (fieldFound.defaultValue != "" ? fieldFound.defaultValue : "");
					switch (inputField.name) {
						case "ssco_utmsource":
							setHiddenFieldValue(inputField, blockElement, UTMSource);
							break;
						case "ssco_utmmedium":
							setHiddenFieldValue(inputField, blockElement, UTMMedium);
							break;
						case "ssco_utmcampaign":
							setHiddenFieldValue(inputField, blockElement, UTMCampaign);
							break;
						case "ssco_utmterm":
							setHiddenFieldValue(inputField, blockElement, UTMTerm);
							break;
						case "ssco_utmcontent":
							setHiddenFieldValue(inputField, blockElement, UTMContent);
							break;
						case "ssco_source_details":
							setHiddenFieldValue(inputField, blockElement, SourceDetailsInput);
							break;
						case "ssco_input_channel":
							setHiddenFieldValue(inputField, blockElement, data.Channel);
							break;
						case "ssco_website_domain":
							setHiddenFieldValue(inputField, blockElement, Domain);
							break;
						case "ssco_landing_pageurl":
							setHiddenFieldValue(inputField, blockElement, SourceDetailsInput);
							break;
						case "ssco_division":
							setHiddenFieldValue(inputField, blockElement, data.Division);
							break;
						case "ssco_preferred_language":
							setHiddenFieldValue(inputField, blockElement, data.PreferredLanguage);
							break;
						case "ssco_leadphase":
							setHiddenFieldValue(inputField, blockElement, data.Leadphase);
							break;
						case "ssco_mergecodes":
							setHiddenFieldValue(inputField, blockElement, data.MergeCodes);
							break;
						case "ssco_absoluteassignment":
							setHiddenFieldValue(inputField, blockElement, data.AbsoluteAssignment);
							break;
						case "ssco_autoassignment":
							var autoAssignment = data.AutoAssignment != "Yes" ? "428980001" : "428980000";
							setHiddenFieldValue(selectField, blockElement, autoAssignment);
							break;
						case "leadsourcecode":
							setHiddenFieldValue(inputField, blockElement, data.LeadSourceDetails);
							break;
						case "subject":
							setHiddenFieldValue(inputField, blockElement, data.Topic);
							break;
						case "ssco_download_pageurl":
							setHiddenFieldValue(inputField, blockElement, data.DownloadPageUrl);
							break;
					}
					if(!fieldFound.isHidden) {
						var fieldLabels = inputField.labels;
						fieldLabels.forEach(fieldLabel => {
							if(debug) console.log(new Date().toLocaleString() + "    Label: " + labelText);
							fieldLabel.innerHTML = labelText != "" ? labelText: fieldLabel.innerHTML;
							fieldLabel.placeholder = placeholderText;
							fieldLabel.title = tooltipText;
						});
						inputField.placeholder = placeholderText;
						inputField.title = tooltipText;
						inputField.value = defaultValue;
						if(fieldFound.isRequired) {
							if(debug) console.log(new Date().toLocaleString() + "    Required" );
							inputField.setAttribute("required", "required");
							blockElement.setAttribute("data-required", "required")
							if(data.Messages["Required"] != "") {
								inputField.addEventListener('invalid',  function() {
									inputField.setCustomValidity('');
									if (!inputField.validity.valid) {
									  inputField.setCustomValidity(data.Messages["Required"]);  
									}
								});	
							}
						} else {
							inputField.removeAttribute("required");
							blockElement.removeAttribute("data-required");
						}
					}
				}
				break;
			case "TextAreaFormField":
				var textareaField = blockElement.querySelector('textarea');
				var fieldFound = false;
				if(textareaField) {
					if(debug) console.log(new Date().toLocaleString() + "   Textarea: " + textareaField.name);
					fieldFound = fields.find(field => field.fieldName.toLowerCase() === textareaField.name.toLowerCase() && (field.isUsed || field.isHidden));
				}
				if(!fieldFound) {
					if(debug) console.log(new Date().toLocaleString() + "    DISABLED");
					blockElement.remove();
				} else {
					const labelText = fieldFound.labelText != "" ? fieldFound.labelText : "";
					const placeholderText = fieldFound.placeholderText != "" ? fieldFound.placeholderText : "";
					const tooltipText = fieldFound.tooltipText != "" ? fieldFound.tooltipText : "";
					const defaultValue = fieldFound.defaultValue != "" ? fieldFound.defaultValue : "";
					var fieldLabels = textareaField.labels;
					fieldLabels.forEach(fieldLabel => {
						if(debug) console.log(new Date().toLocaleString() + "    Label: " + labelText);
						fieldLabel.innerHTML = labelText != "" ? labelText: fieldLabel.innerHTML;
						fieldLabel.placeholder = placeholderText;
						fieldLabel.title = tooltipText;
					});
					textareaField.placeholder = placeholderText;
					textareaField.title = tooltipText;
					if(fieldFound.isRequired) {
						if(debug) console.log(new Date().toLocaleString() + "    Required" );
						textareaField.setAttribute("required", "required");
						blockElement.setAttribute("data-required", "required")
						if(data.Messages["Required"] != "") {
							textareaField.addEventListener('invalid',  function() {
								textareaField.setCustomValidity('');
								if (!textareaField.validity.valid) {
								  textareaField.setCustomValidity(data.Messages["Required"]);  
								}
							});	
						}
					} else {
						textareaField.removeAttribute("required");
						blockElement.removeAttribute("data-required");
					}
				}
				break;
			case "OptionSetFormField":
				var selectField = blockElement.querySelector('select');
				var fieldFound = false;
				if(selectField) {
					if(debug) console.log(new Date().toLocaleString() + "   Select: " + selectField.name);
					fieldFound = fields.find(field => field.fieldName.toLowerCase() === selectField.name.toLowerCase() && (field.isUsed || field.isHidden));
				}
				if(!fieldFound) {
					if(debug) console.log(new Date().toLocaleString() + "    DISABLED");
					blockElement.remove();
				} else {
					const labelText = fieldFound.labelText != "" ? fieldFound.labelText : "";
					const placeholderText = fieldFound.placeholderText != "" ? fieldFound.placeholderText : "";
					const tooltipText = fieldFound.tooltipText != "" ? fieldFound.tooltipText : "";
					const defaultValue = (fieldFound.defaultValue != "" ? fieldFound.defaultValue : "").toLowerCase().replace('/',' ');
					const options = selectField.options;
					var fieldLabels = selectField.labels;
					fieldLabels.forEach(fieldLabel => {
						if(debug) console.log(new Date().toLocaleString() + "    Label: " + labelText);
						fieldLabel.innerHTML = labelText;
						fieldLabel.placeholder = placeholderText;
						fieldLabel.title = tooltipText;
					});
					selectField.placeholder = placeholderText;
					selectField.title = tooltipText;
					if(debug) console.log(new Date().toLocaleString() + "    Options: " + options);
					if(options && options.forEach) {
						var i = 0
						options.forEach(option => {
							if(i == 0) {
								if(placeholderText != "") { 
									if(debug) console.log(new Date().toLocaleString() + "    Option0: " + placeholderText);
									option.text = placeholderText;
								}
							} else {
								const text = option.text.replace('/',' ').toLowerCase();
								if(text == defaultValue) {
									if(debug) console.log(new Date().toLocaleString() + "    Selected");
									option.selected = true;
								}
								if(fieldFound.Options[text]) {
									if(debug) console.log(new Date().toLocaleString() + "    Option: " + fieldFound.Options[text]);
									option.text = fieldFound.Options[text];
								}
							}
							i++;
						});
					}
					switch (selectField.name) {
						case "ssco_utmsource":
							setHiddenFieldValue(selectField, blockElement, UTMSource);
							break;
						case "ssco_utmmedium":
							setHiddenFieldValue(selectField, blockElement, UTMMedium);
							break;
						case "ssco_utmcampaign":
							setHiddenFieldValue(selectField, blockElement, UTMCampaign);
							break;
						case "ssco_utmterm":
							setHiddenFieldValue(selectField, blockElement, UTMTerm);
							break;
						case "ssco_utmcontent":
							setHiddenFieldValue(selectField, blockElement, UTMContent);
							break;
						case "ssco_source_details":
							setHiddenFieldValue(selectField, blockElement, SourceDetailsInput);
							break;
						case "ssco_input_channel":
							setHiddenFieldValue(selectField, blockElement, data.Channel);
							break;
						case "ssco_website_domain":
							setHiddenFieldValue(selectField, blockElement, Domain);
							break;
						case "ssco_landing_pageurl":
							setHiddenFieldValue(selectField, blockElement, SourceDetailsInput);
							break;
						case "ssco_division":
							setHiddenFieldValue(selectField, blockElement, data.Division);
							break;
						case "ssco_preferred_language":
							setHiddenFieldValue(selectField, blockElement, data.PreferredLanguage);
							break;
						case "ssco_leadphase":
							setHiddenFieldValue(selectField, blockElement, data.Leadphase);
							break;
						case "ssco_mergecodes":
							setHiddenFieldValue(selectField, blockElement, data.MergeCodes);
							break;
						case "ssco_absoluteassignment":
							setHiddenFieldValue(selectField, blockElement, data.AbsoluteAssignment);
							break;
						case "ssco_autoassignment":
							var autoAssignment = data.AutoAssignment != "Yes" ? "428980001" : "428980000";
							setHiddenFieldValue(selectField, blockElement, autoAssignment);
							break;
						case "leadsourcecode":
                            setHiddenFieldValue(selectField, blockElement, data.LeadSourceDetails);
							break;
						case "subject":
							setHiddenFieldValue(selectField, blockElement, data.Topic);
							break;
						case "ssco_download_pageurl":
							setHiddenFieldValue(selectField, blockElement, data.DownloadPageUrl);
							break;
					}
					if(fieldFound.isRequired) {
						if(debug) console.log(new Date().toLocaleString() + "    Required" );
						selectField.setAttribute("required", "required");
						blockElement.setAttribute("data-required", "required")
						if(data.Messages["Required"] != "") {
							selectField.addEventListener('invalid',  function() {
								selectField.setCustomValidity('');
								if (!selectField.validity.valid) {
								  selectField.setCustomValidity(data.Messages["Required"]);  
								}
							});	
						}
					} else {
						selectField.removeAttribute("required");
						blockElement.removeAttribute("data-required");
					}
				}
				break;
			case "MultiOptionSetFormField":
				var fieldsetField = blockElement.querySelector('fieldset');
				var fieldFound = false;
				if(fieldsetField) {
					if(debug) console.log(new Date().toLocaleString() + "   Fieldset: " + fieldsetField.name);
					fieldSetInputs = fieldsetField.querySelectorAll('input');
					fieldSetInputs.forEach(fieldSetInput => {
						fieldFound = fields.find(field => field.fieldName.toLowerCase() === fieldSetInput.name.toLowerCase() && (field.isUsed || field.isHidden));
					});
				}
				if(!fieldFound) {
					if(debug) console.log(new Date().toLocaleString() + "   DISABLED");
					blockElement.remove();
				} else {
					const labelText = fieldFound.labelText != "" ? fieldFound.labelText : "";
					const placeholderText = fieldFound.placeholderText != "" ? fieldFound.placeholderText : "";
					const tooltipText = fieldFound.tooltipText != "" ? fieldFound.tooltipText : "";
					const defaultValue = fieldFound.defaultValue != "" ? fieldFound.defaultValue : "";
					fieldsetField.title = tooltipText;
					const fieldsetLabel = blockElement.querySelector('label');
					if(debug) console.log("   Label: " + fieldsetLabel.innerHTML);
					fieldsetLabel.innerHTML = labelText;
					fieldsetLabel.placeholder = placeholderText;
					fieldsetLabel.title = tooltipText;
					fieldSetInputs.forEach(fieldSetInput => {
						if(debug) console.log("    Checkbox: " + fieldSetInput.id);
						fieldSetInputLabels = fieldSetInput.labels;
						fieldSetInputLabels.forEach(fieldSetInputLabel => {
							const text = fieldSetInputLabel.innerHTML.replace('/',' ').toLowerCase();
							if(debug) console.log(new Date().toLocaleString() + "        Label: " + text);
							if(fieldFound.Options[text]) {
								if(debug) console.log("     Replaced: " + fieldFound.Options[text]);
								fieldSetInputLabel.innerHTML = fieldFound.Options[text];
								fieldSetInputLabel.title = fieldFound.Options[text];
								fieldSetInput.title = fieldFound.Options[text];
							}
						});
					});
					if(fieldFound.isRequired) {
						if(debug) console.log(new Date().toLocaleString() + "    Required" );
						fieldsetField.setAttribute("required", "required");
						blockElement.setAttribute("data-required", "required")
						if(data.Messages["Required"] != "") {
							fieldsetField.addEventListener('invalid',  function() {
								fieldsetField.setCustomValidity('');
								if (!fieldsetField.validity.valid) {
								  fieldsetField.setCustomValidity(data.Messages["Required"]);  
								}
							});	
						}
					} else {
						fieldsetField.removeAttribute("required");
						blockElement.removeAttribute("data-required");
					}
				}
				break;
			default:
				console.error(new Date().toLocaleString() + " Unsupported block type: " + blockType);
				blockElement.remove();
				break;
		}
    });	
	if(debug) console.log(new Date().toLocaleString() + " BlockStyle: " + blockStyle);
	
	if(submitButtonBlock) {
		if(data.Purposes) {
			const Purposes = data.Purposes;
			if(Purposes.length > 0) {
				for (let i = 0; i < Purposes.length; i++) {
					consentCheckboxName = "consentCheckbox-" + i
					consentHtml = "";
					consentHtml = consentHtml + "<div class='consentBlock' data-editorblocktype='Consent' data-required='true' style='" + blockStyle + "'>";
					consentHtml = consentHtml + "<div>";
					consentHtml = consentHtml + "<input type='checkbox' id='" + consentCheckboxName + "' name='" + consentCheckboxName + "' required='' value='" + Purposes[i].purposeid + "'>";
					consentHtml = consentHtml + "<label id='" + consentCheckboxName + "-label' for='" + consentCheckboxName + "'><p>" + Purposes[i].translation + "</p></label>";
					consentHtml = consentHtml + "</div>";
					consentHtml = consentHtml + "</div>	";
					submitButtonBlock.insertAdjacentHTML('beforebegin', consentHtml);
				}
			}
		}
		if(data.Topics) {
			const topics = data.Topics;
			if(topics.length > 0) {
				for (let i = 0; i < topics.length; i++) {
					topicCheckboxName = "topicCheckbox-" + i
					topicHtml = "";
					topicHtml = topicHtml + "<div class='consentBlock' data-editorblocktype='Topic' style='" + blockStyle + "'>";
					topicHtml = topicHtml + "<div>";
					topicHtml = topicHtml + "<input type='checkbox' id='" + topicCheckboxName + "' name='" + topicCheckboxName + "' value='" + topics[i].topicid + "'>";
					topicHtml = topicHtml + "<label id='" + topicCheckboxName + "-label' for='" + topicCheckboxName + "'>" + topics[i].translation + "</label>";
					topicHtml = topicHtml + "</div>";
					topicHtml = topicHtml + "</div>	";
					submitButtonBlock.insertAdjacentHTML('beforebegin', topicHtml);
				}
			}
		}
		if(data.Messages["Required"] != "") {
			const blockElements = shadowRoot.querySelectorAll("[data-editorblocktype='Consent']");
			blockElements.forEach(blockElement => {
				var inputField = blockElement.querySelector('input');
				if(inputField) {
					if(debug) console.log(new Date().toLocaleString() + " Consent: " + inputField.name);
					if(debug) console.log(new Date().toLocaleString() + "   Required ");
					inputField.addEventListener('invalid',  function() {
						inputField.setCustomValidity('');
						if (!inputField.validity.valid) {
						  inputField.setCustomValidity(data.Messages["Required"]);  
						}
					});	
				}
			});
		}
	}
	document.getElementById("loader").style.display = "none";
	formElement.style.display= "";
	
	console.log(new Date().toLocaleString() + " d365mkt-afterformload ended");	
}

	
function setHiddenFieldValue(fieldElement, fieldParent, fieldValue) {
	fieldElement.removeAttribute("required");
	fieldElement.removeAttribute("pattern");
	fieldParent.removeAttribute("data-required")
	if(fieldValue == "") {
		return;
	}
	if(fieldElement.type == "select-one") {
		 const selectOptionValue = fieldElement.querySelector('option[value="' + fieldValue + '"]');
		 if (selectOptionValue) {
			selectOptionValue.selected = true;
			return;
		 }
	} else {
		fieldElement.value = fieldValue;
	}
}
	 
function getUTMParamsFromCookie() {
	var utmParams = {};
	var cookieValue = decodeURIComponent(document.cookie.replace(/(?:(?:^|.*;\s*)spray-utm\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
	if (cookieValue) {
		var queryParams = new URLSearchParams(cookieValue);
		if (queryParams.has("utm_source")) {
			utmParams.source = queryParams.get("utm_source");
		}
		if (queryParams.has("utm_medium")) {
			utmParams.medium = queryParams.get("utm_medium");
		}
		if (queryParams.has("utm_campaign")) {
			utmParams.campaign = queryParams.get("utm_campaign");
		}
		if (queryParams.has("utm_content")) {
			utmParams.content = queryParams.get("utm_content");
		}
		if (queryParams.has("utm_term")) {
			utmParams.term = queryParams.get("utm_term");
		}
	}
	return utmParams;
}
